import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionComments } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemInternalTransaction from '../hooks/use-internal';

const InternalTransactionComments = (): React.JSX.Element => {
  const { transactionComments, transactionCommentsPagination } = useAppSelector(
    (state) => state.customersProblemTransactions.internal,
  );
  const { users } = useAppSelector((state) => state.administrationDictionaries);
  const { activePermissions } = useAppSelector((state) => state.root);

  const { transactionId } = useParams();

  const {
    getTransactionCommentsAction,
    commentsIsLoading,
    commentsIsFetching,
    onAddCommentToTransaction,
    addCommentInProgress,
    addCommentIsSuccess,
    onEditCommentInTransaction,
    editTransactionCommentInProgress,
    editTrancastionCommentIsSuccess,
    onDeleteCommentInTransaction,
    deleteCommentInTransactionInProgress,
    deleteCommentInTranscationIsSuccess,
  } = useProblemInternalTransaction({
    transactionId,
  });

  useEffect(() => {
    if (
      activePermissions?.includes(
        PermissionEnum.TRANSACTIONS_INTERNAL_COMMENTS_LIST,
      )
    ) {
      getTransactionCommentsAction();
    }
  }, [activePermissions]);

  return (
    <TransactionComments
      comments={transactionComments}
      pagination={transactionCommentsPagination}
      isLoading={commentsIsLoading}
      isFetching={commentsIsFetching}
      commentsAvailable={activePermissions?.includes(
        PermissionEnum.TRANSACTIONS_INTERNAL_COMMENTS_LIST,
      )}
      getCommentsList={getTransactionCommentsAction}
      createAvailable={activePermissions?.includes(
        PermissionEnum.TRANSACTIONS_INTERNAL_COMMENTS_CREATE_ACTION,
      )}
      editAvailable={activePermissions?.includes(
        PermissionEnum.TRANSACTIONS_INTERNAL_COMMENTS_EDIT_ACTION,
      )}
      deleteAvailable={activePermissions?.includes(
        PermissionEnum.TRANSACTIONS_INTERNAL_COMMENTS_DELETE_ACTION,
      )}
      onAddCommentToTransaction={onAddCommentToTransaction}
      addCommentInProgress={addCommentInProgress}
      addCommentIsSuccess={addCommentIsSuccess}
      onEditCommentInTransaction={onEditCommentInTransaction}
      editTransactionCommentInProgress={editTransactionCommentInProgress}
      editTrancastionCommentIsSuccess={editTrancastionCommentIsSuccess}
      users={users}
      onDeleteCommentInTransaction={onDeleteCommentInTransaction}
      deleteCommentInTransactionInProgress={
        deleteCommentInTransactionInProgress
      }
      deleteCommentInTranscationIsSuccess={deleteCommentInTranscationIsSuccess}
      changeLogsAvailable={activePermissions?.includes(
        PermissionEnum.AUDIT_LOG_LIST,
      )}
    />
  );
};

export default InternalTransactionComments;
